import styles from "./footer.module.css";

const Footer = () => {

  return (<div className={`${styles.FooterFluid}`}>
    <div className={`${styles.FooterContainer} ${styles.Container}`}>
      <div className={`${styles.Container}`}>
        <p className={`${styles.CopyText}`}>©2025 Ezy Freight Logistics, All Right Reserved</p>
      </div>
    </div>
  </div>);
}

export default Footer;